import { Typography, Input, IconButton, Spinner, Chip } from '@material-tailwind/react'
import { FiRefreshCw } from 'react-icons/fi'

export function HeaderBar({ loading, count, q, setQ, onRefresh }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <IconButton variant="text" onClick={onRefresh} title="Actualizar">
        {loading ? <Spinner className="h-4 w-4" /> : <FiRefreshCw />}
      </IconButton>
      <Typography variant="small" className="text-gray-600">
        Aprobadas, ventana activa ahora
      </Typography>
      <Chip value={`${count} vigentes`} size="sm" className="rounded-full ml-2" color="green" />
      <div className="ml-auto w-full sm:w-64">
        <Input
          label="Buscar"
          value={q}
          onChange={e => setQ(e.target.value)}
          crossOrigin=""
          containerProps={{ className: 'w-full min-w-0' }}
          className="!w-full min-w-0"
        />
      </div>
    </div>
  )
}